// extracted by mini-css-extract-plugin
export default {"ForumSearch__headline":"qp_a bie_sn bie_va","ForumSearch__img":"qp_b","ForumSearch__searchAdsAndShoppingAds":"qp_c","ForumSearch__results--empty":"qp_e"};